<template>
<!--<div id="footer">-->
<!--  <p class="copyright"> 金域医学健康体检系统 &copy; 2024 </p>-->
<!--</div>-->
</template>
<script>
export default {
  name: "IFooter"
};
</script>
<style lang="postcss" scoped>
#footer {
  width: 100%;
  position: fixed;
  bottom: 0;
  z-index: 89;

  background-color: #fff;
  color: #666;
  text-align: center;
  & .copyright {
    margin: 10px 0;
  }
}
</style>
